import React, { useEffect, useState, useRef } from "react";
import { Spinner } from "reactstrap";

import { useFetch } from "../Base/Hooks/fetch.js";
import PageDisplay from "../Base/PageDisplay/PageDisplay.jsx";
import FormBuilder from "../Base/Forms/FormBuilder.jsx";
import formSetup from "./formSetup.js";
import locales from "../../config/locales.js";

const EditVenueInput = (props) => {
  const { title, history, match, sport } = props;
  const [refreshData, setRefreshData] = useState(true);
  const [currentVenueInput, setCurrentVenueInput] = useState(null);
  const pageRef = useRef();
  const { error, loading, data } = useFetch(
    "/v1/" + sport + "/video/inputs/" + match.params.videoInputId + "?hideNull=false",
    "",
    refreshData,
  );
  const LookupData = [];
  LookupData["locales"] = locales;

  useEffect(() => {
    if (data && data.data && data.data[0]) {
      setRefreshData(false);
      setCurrentVenueInput({ sport, ...data.data[0] });
    }
  }, [data, sport]);

  function reloadData() {
    setRefreshData(true);
  }

  return (
    <PageDisplay
      title="Update Master Venue Video Input"
      error={error}
      pageTitle={"Update Master Venue Video Input - " + title}
      ref={pageRef}
      history={history}
    >
      {loading && <Spinner size="md" color="orange" />}
      {currentVenueInput && (
        <div>
          <h4>{currentVenueInput.name}</h4>
          <FormBuilder
            form="EditVenueInput"
            action={reloadData}
            formSetup={formSetup}
            formData={currentVenueInput}
            pageRef={pageRef}
            lookupData={LookupData}
          />
          {error}
        </div>
      )}
    </PageDisplay>
  );
};

export default EditVenueInput;
